<div class="modal-header justify-content-end">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <div class="edit-tools clearfix">
    <div class="tool font-family">
      <b>Font</b>
      <div ngbDropdown class="d-inline-block">
        <div id="font-family" [ngStyle]="{'font-family': clip.font.font_family}" ngbDropdownToggle>{{clip.font.font_family}}</div>
        <div ngbDropdownMenu aria-labelledby="font-family">
          <div [ngStyle]="{'font-family': font.family}" *ngFor="let font of fontService.getFonts()" (click)="clip.font.font_family = font.family" class="dropdown-item">{{ font.title }}</div>
        </div>
      </div>
    </div>
    <div class="tool font-weight-select">
      <b>Weight</b>
      <div ngbDropdown class="d-inline-block">
        <div id="font-weight" ngbDropdownToggle #fontWeightDiv>{{getWeightName()}}</div>
        <div ngbDropdownMenu aria-labelledby="font-weight">
          <div *ngFor="let weight of fontService.getWeightsByFamily(clip.font.font_family)" (click)="clip.font.font_weight = weight.weight; fontWeightDiv.value = weight.title" class="dropdown-item">{{ weight.title }}</div>
        </div>
      </div>
    </div>
    <div class="tool font-size">
      <div ngbDropdown class="d-inline-block">
        <div id="font-size" ngbDropdownToggle>{{clip.font.font_size}}</div>
        <div ngbDropdownMenu aria-labelledby="font-size">
          <div *ngFor="let size of fontService.fontSizes" (click)="clip.font.font_size = size.title" class="dropdown-item">{{ size.title }}</div>
        </div>
      </div>
    </div>
    <div class="tool font-weight" [ngClass]="{'active' : clip.font.font_weight === 700}" (click)="clip.font.swapFontBold()"></div>
    <div class="tool text-decoration" [ngClass]="{'active' : clip.font.text_decoration === 'underline'}" (click)="clip.font.swapTextUnderline()"></div>
    <div class="tool font-style" [ngClass]="{'active' : clip.font.font_style === 'italic'}" (click)="clip.font.swapFontItalic()"></div>
    <div class="tool font-color" [ngClass]="{'active' : colorToggle}"
         [(colorPicker)]="clip.font.color"
         [cpPosition]="'bottom'"
         [cpPositionOffset]="'50%'"
         [cpPositionRelativeToArrow]="true"
         (cpToggleChange)="colorToggle = $event"></div>
    <div class="tool background-color" [ngClass]="{'active' : bgColorToggle}"
         [(colorPicker)]="clip.background_color"
         (colorPickerChange)="changeClipBackgroundColor($event)"
         [cpPosition]="'bottom'"
         [cpPositionOffset]="'50%'"
         [cpOutputFormat]="'hex'"
         [cpAlphaChannel]="'always'"
         [cpPositionRelativeToArrow]="true"
         (cpToggleChange)="bgColorToggle = $event"></div>
    <div class="tool text-align-left" [ngClass]="{'active' : clip.font.text_align === 'left'}" (click)="clip.font.setTextAlign('left')"></div>
    <div class="tool text-align-center" [ngClass]="{'active' : clip.font.text_align === 'center'}" (click)="clip.font.setTextAlign('center')"></div>
    <div class="tool text-align-right" [ngClass]="{'active' : clip.font.text_align === 'right'}" (click)="clip.font.setTextAlign('right')"></div>
  </div>

  <div appEditableDiv class="text-edit-box" [ngStyle]="getStyle(clip.font)" contenteditable="true" [(ngModel)]="clip.text"></div>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-default" (click)="activeModal.dismiss('Cancel click')">{{ 'CANCEL' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="finishTextEditing()">{{ 'OK' | translate }}</button>
  <button type="button" class="btn btn-primary" *ngIf="clip.transcription" (click)="finishTextEditing(true)">{{ 'Apply to all' | translate }}</button>
  <span class="lock-subtitle" *ngIf="clip.transcription" (click)="lockToggle(clip)"><i class="fa" [ngClass]="{'fa-lock': !clip.unlocked, 'fa-unlock': clip.unlocked}"></i> {{ clip.unlocked ? 'Unlock' : 'Lock' | translate }} <i class="fa fa-info-circle text-primary" [ngbTooltip]="'You can change subtitle position individually or all at the same time.'"></i></span>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/text-editor/text-editor.component.html